"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const mongo_1 = require("../utility/mongo");
exports.OfferSchema = joi_1.default.object({
    _id: mongo_1.ObjectIdSchema,
    createdAt: joi_1.default.date(),
    updatedAt: joi_1.default.date(),
    acceptedAt: joi_1.default.date(),
    createdBy: joi_1.default.any().allow('offer', 'calendar', 'manual').required(),
    photographerEarnings: joi_1.default.number().required(),
    photographerWage: joi_1.default.number().required(),
    photographerWageCurrency: joi_1.default.string().required(),
    photographerUuid: joi_1.default.string().required(),
    travelCost: joi_1.default.number().required(),
    travelDistance: joi_1.default.number().required(),
    travelDuration: joi_1.default.number().required(),
    travelStart: joi_1.default.string().allow(null),
    shootUuid: joi_1.default.string().required(),
    uuid: joi_1.default.string().required(),
    batchInfo: joi_1.default.object({
        length: joi_1.default.number().required(),
        skippedCandidates: joi_1.default.number().required(),
        totalCandidates: joi_1.default.number().required()
    })
}).meta({ className: 'Offer' });
//# sourceMappingURL=OfferSchema.js.map